module.exports = __webpack_public_path__ + "img/08a-osm-solicitacao-modal.b9edd969.png";